import { Directive, Input, SimpleChanges, ElementRef, OnChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Directive({
  selector: '[renciLoadHtml]'
})
export class LoadHtmlDirective implements OnChanges {

  @Input()
  renciLoadHtml: string;

  constructor(
    private authHttp: HttpClient,
    private elem: ElementRef) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.renciLoadHtml) {
      const content = await this.authHttp.get('./assets/home.content.html', { responseType: 'text' }).toPromise();
      this.elem.nativeElement.insertAdjacentHTML('beforeend', content);
    }
  }
}
